import { useState, useEffect } from 'react';
import { getAccessToken } from '../utils/auth';
import DatasourceEdit from './datasource-edit';

function Datasources({ onEdit }) {
  const [datasources, setDatasources] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'modified', direction: 'desc' });
  const [searchFilter, setSearchFilter] = useState('');
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showMenu, setShowMenu] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [datasourceToDelete, setDatasourceToDelete] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [resultSuccess, setResultSuccess] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });
  };

  const filteredDatasources = datasources.filter(ds => {
    if (searchFilter.length < 3) return true;
    return ds.display_name?.toLowerCase().includes(searchFilter.toLowerCase());
  });

  const sortedDatasources = [...filteredDatasources].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aValue = a[sortConfig.key]?.toString().toLowerCase() || '';
    const bValue = b[sortConfig.key]?.toString().toLowerCase() || '';
    return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
  });

  useEffect(() => {
    const fetchDatasources = async () => {
      const token = await getAccessToken();
      if (token) {
        fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/datasource`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
          .then(response => response.json())
          .then(data => setDatasources(data))
          .catch(error => console.error('Error fetching datasources:', error));
      }
    };
    fetchDatasources();
  }, []);



  return (
    <div>
      <div className="header-layout">
        <h2 className="header-title">Data Sources</h2>
        <button className="btn-add" onClick={() => onEdit("0")}>
          Add Data Source
        </button>
      </div>
      <input
        type="text"
        className="form-input"
        placeholder="Search data sources..."
        value={searchFilter}
        onChange={(e) => setSearchFilter(e.target.value)}
        style={{ marginBottom: '20px', width: '300px' }}
      />
      {/* <div className="scrollable-table-wrapper datasources-table"> */}
      {/* <div className="scrollable-table-wrapper"> */}
      {/* <div className="datasources-table"> */}
        <table className="data-table datasources-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('type')} style={{ cursor: 'pointer' }}>Type</th>
              <th onClick={() => handleSort('display_name')} style={{ cursor: 'pointer' }}>Name</th>
              <th onClick={() => handleSort('description')} style={{ cursor: 'pointer' }}>Description</th>
              <th onClick={() => handleSort('created')} style={{ cursor: 'pointer' }}>Created</th>
              <th onClick={() => handleSort('modified')} style={{ cursor: 'pointer' }}>Modified</th>
              <th style={{ width: '50px' }}></th>
            </tr>
          </thead>
          <tbody>
            {sortedDatasources.map((ds, index) => (
              <tr key={index} onMouseEnter={() => setHoveredRow(index)} onMouseLeave={() => setHoveredRow(null)}>
                <td data-column="type"><img src={`/media/${ds.type.toLowerCase()}-icon.png`} alt={ds.type} style={{ width: '24px', height: '24px' }} /></td>
                <td data-column="display_name" onClick={() => onEdit(ds.id)} style={{ cursor: 'pointer' }}>{ds.display_name}</td>
                <td data-column="description" title={ds.description}>{ds.description}</td>
                <td data-column="created" onClick={() => onEdit(ds.id)} style={{ cursor: 'pointer' }}>{formatDate(ds.created)}</td>
                <td data-column="modified" onClick={() => onEdit(ds.id)} style={{ cursor: 'pointer' }}>{formatDate(ds.modified)}</td>
                <td data-column= "actions" className="agents-actions-cell">
                  {hoveredRow === index && (
                    <span 
                      onMouseEnter={() => setShowMenu(index)}
                      className="agents-ellipsis"
                    >
                      ⋯
                    </span>
                  )}
                  {showMenu === index && (
                    <div 
                      onMouseEnter={() => setShowMenu(index)}
                      onMouseLeave={() => setShowMenu(null)}
                      className="agents-menu"
                    >
                      <div onClick={() => { onEdit(ds.id); setShowMenu(null); }} className="agents-menu-item">Edit</div>
                      <div onClick={() => { setDatasourceToDelete(ds); setShowDeleteModal(true); setShowMenu(null); }} className="agents-menu-item">Delete</div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      {/* </div> */}

      {showDeleteModal && datasourceToDelete && (
        <div className="modal-overlay">
          <div className="modal-content modal-content-compact">
            <h3>Delete Data Source</h3>
            <p>All associated configurations and data will be deleted.</p>
            <p>Are you sure you want to delete the data source "{datasourceToDelete.display_name}"?</p>
            <div className="modal-buttons">
              <button className="btn-cancel" onClick={() => { setShowDeleteModal(false); setDatasourceToDelete(null); }}>Cancel</button>
              <button className="btn-save" onClick={async () => {
                const token = await getAccessToken();
                if (token) {
                  try {
                    const response = await fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/datasource/${datasourceToDelete.id}`, {
                      method: 'DELETE',
                      headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (response.ok) {
                      setDatasources(datasources.filter(d => d.id !== datasourceToDelete.id));
                      setResultSuccess(true);
                      setResultMessage(`${datasourceToDelete.display_name} successfully deleted`);
                    } else {
                      const errorData = await response.json();
                      setResultSuccess(false);
                      setResultMessage(errorData.message || 'Failed to delete');
                    }
                    setShowResultModal(true);
                  } catch (error) {
                    setResultSuccess(false);
                    setResultMessage('Error deleting data source: ' + error.message);
                    setShowResultModal(true);
                  }
                }
                setShowDeleteModal(false);
                setDatasourceToDelete(null);
              }}>Yes</button>
            </div>
          </div>
        </div>
      )}
      {showResultModal && (
        <div className="modal-overlay">
          <div className="modal-content modal-content-compact">
            <h3>{resultSuccess ? 'Deleted' : 'Unable to delete'}</h3>
            <p>{resultMessage}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowResultModal(false)} className="btn-save">OK</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Datasources;